import React, { createContext, useContext, useState, ReactNode } from 'react';
import GlobalLoader from './GlobalLoader'; // Import the main loader component

interface LoaderContextType {
  showLoader: (text?: string,warning?: string) => void;
  hideLoader: () => void;
  loading: boolean;
  text: string;
  warningText:string | null; // Add text to the context type
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

export const useLoader = () => {
  const ctx = useContext(LoaderContext);
  if (!ctx) throw new Error("useLoader must be used within LoaderProvider");
  return ctx;
};

export const LoaderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState(''); // Add state for the loader text
  const [warningText, setWarningText] = useState<string | null>(null); 

  const showLoader = (loaderText = 'Loading...', warning?:string) => {
    setLoading(true);
    setText(loaderText);
    setWarningText(warning || null)
  };

  const hideLoader = () => {
    setLoading(false);
    setText('');
  };

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader, loading, text, warningText }}>
      {children}
      {/* Render the GlobalLoader, which will consume the context */}
      <GlobalLoader />
    </LoaderContext.Provider>
  );
};
 